import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import LuxuryNavbar from "./components/LuxuryNavbar";
import LuxuryFooter from "./components/LuxuryFooter";
import CookieBanner from "./components/CookieBanner";
import SEOHead from "./components/SEOHead";
import { Toaster } from "./components/ui/sonner";
import NewHome from "./pages/NewHome";
import Evoke from "./pages/Evoke";
import About from "./pages/About";
import NewVentures from "./pages/NewVentures";
import NewShop from "./pages/NewShop";
import NewBlog from "./pages/NewBlog";
import NewContact from "./pages/NewContact";
import CianoGourmet from "./pages/ventures/CianoGourmet";
import CianoBites from "./pages/ventures/CianoBites";
import StaffDO from "./pages/ventures/StaffDO";
import KoraOS from "./pages/ventures/KoraOS";
import Features from "./pages/Features";
import Policies from "./pages/Policies";
import SelectedMoments from "./pages/SelectedMoments";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminServices from "./pages/admin/AdminServices";
import AdminLanes from "./pages/admin/AdminLanes";
import AdminImages from "./pages/admin/AdminImages";
import AdminImagesShowit from "./pages/admin/AdminImagesShowit";
import AdminSEOSettings from "./pages/admin/AdminSEOSettings";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminSubscribers from "./pages/admin/AdminSubscribers";
import AdminSites from "./pages/admin/AdminSites";
import ProtectedRoute from "./pages/admin/ProtectedRoute";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Layout wrapper for public pages
function PublicLayout({ children }) {
  return (
    <>
      <LuxuryNavbar />
      {children}
      <LuxuryFooter />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
    <SiteProvider>
    <LanguageProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes with Navbar/Footer */}
          <Route path="/" element={<PublicLayout><NewHome /></PublicLayout>} />
          <Route path="/evoke" element={<PublicLayout><Evoke /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/ventures" element={<PublicLayout><NewVentures /></PublicLayout>} />
          <Route path="/ventures/ciano-gourmet" element={<PublicLayout><CianoGourmet /></PublicLayout>} />
          <Route path="/ventures/ciano-bites" element={<PublicLayout><CianoBites /></PublicLayout>} />
          <Route path="/ventures/staffdo" element={<PublicLayout><StaffDO /></PublicLayout>} />
          <Route path="/ventures/kora-os" element={<PublicLayout><KoraOS /></PublicLayout>} />
          <Route path="/shop" element={<PublicLayout><NewShop /></PublicLayout>} />
          <Route path="/studio" element={<PublicLayout><NewShop /></PublicLayout>} />
          <Route path="/blog" element={<PublicLayout><NewBlog /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><NewContact /></PublicLayout>} />
          <Route path="/features" element={<PublicLayout><Features /></PublicLayout>} />
          <Route path="/selected-moments" element={<PublicLayout><SelectedMoments /></PublicLayout>} />
          <Route path="/policies" element={<PublicLayout><Policies /></PublicLayout>} />

          {/* Admin Routes - No public Navbar/Footer */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/blog" element={<AdminBlog />} />
              <Route path="/admin/products" element={<AdminProducts />} />
              <Route path="/admin/services" element={<AdminServices />} />
              <Route path="/admin/lanes" element={<AdminLanes />} />
              <Route path="/admin/images" element={<AdminImagesShowit />} />
              <Route path="/admin/images-legacy" element={<AdminImages />} />
              <Route path="/admin/seo" element={<AdminSEOSettings />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/admin/contacts" element={<AdminContacts />} />
              <Route path="/admin/subscribers" element={<AdminSubscribers />} />
              <Route path="/admin/sites" element={<AdminSites />} />
            </Route>
          </Route>
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
    </LanguageProvider>
    </SiteProvider>
    </AuthProvider>
  );
}

export default App;
